export { ClearButton, mapTextInputSizeToButtonSize } from './ClearButton/ClearButton';
